import { cn } from "app/lib/utils";

interface PendingProps {
  readonly label: string;
}

interface CompletedProps {
  readonly label: string;
  readonly success: boolean;
}

export function ToolCallPending({ label }: PendingProps) {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-500 py-1">
      <svg
        className="animate-spin w-3.5 h-3.5 text-blue-400 shrink-0"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
      <span className="shimmer shimmer-color-sapphire-80">
        Calling {label}...
      </span>
    </div>
  );
}

export function ToolCallCompleted({ label, success }: CompletedProps) {
  return (
    <div className={cn("flex items-center gap-1.5 text-sm py-1", success ? "text-gray-500" : "text-red-500")}>
      {success ? (
        <svg className="w-3.5 h-3.5 text-green-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      ) : (
        <svg className="w-3.5 h-3.5 text-red-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        </svg>
      )}
      <span>{success ? label : `${label} failed`}</span>
    </div>
  );
}
